// auth.ts

// ------------------
// Decode JWT
// ------------------
export function decodeJwt(token: string | null): any | null {
  if (!token) return null;

  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

// ------------------
// Check expiration
// ------------------
export function isExpired(token: string | null): boolean {
  if (!token) return true;

  const decoded = decodeJwt(token);

  if (!decoded?.exp) return true;

  return decoded.exp * 1000 < Date.now();
}

// ------------------
// Get valid backend JWT
// ------------------
export async function getValidIdToken(): Promise<string> {
  const token = sessionStorage.getItem("access_token");

  if (!token) {
    window.location.href = "/login";
    throw new Error("No token found");
  }

  if (isExpired(token)) {
    sessionStorage.clear();
    window.location.href = "/login";
    throw new Error("Token expired");
  }

  return token;
}

// ------------------
// Optional helpers
// ------------------
export function getTenantId(): string | null {
  const token = sessionStorage.getItem("access_token");

  const decoded = decodeJwt(token);

  return decoded?.tenant_id ?? null;
}

export function getUsername(): string | null {
  const token = sessionStorage.getItem("access_token");

  const decoded = decodeJwt(token);

  return decoded?.sub ?? null;
}